import $ from 'jquery'
import {FORMAT} from '../config/const'
import React from 'react'

const moment = require('moment')

Array.prototype.equal = function (array) {
  const a = JSON.parse(JSON.stringify(this)).sort()
  const b = JSON.parse(JSON.stringify(array)).sort()

  return a.join(',') == b.join(',')
}

String.prototype.dateFormat = function (format = FORMAT.DATE_TIME) {
  return moment(this).isValid() ? moment(this).format(format) : ''
}

$.fn.dateFormat = (date, format = FORMAT.DATE) => {
  return date.toString().dateFormat(format)
}
